<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <el-form :model="agreementForm" ref="agreementForm" :rules="agreementFormRules" label-width="120px" size="medium"
        style="padding-right: 10%;" class="demo-form-inline">
        <el-row>
          <el-col :span="11">
            <el-form-item label="标题">
              <el-input clearable v-model="agreementForm.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">

            <el-form-item label="协议类型" prop="endTime">
              <el-select v-model="categorySelect" @change="categorySelectChange" placeholder="请选择状态">
                <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="内容">
          <argeement-edit v-on:listenToChildEvent="showMsgFromEdit"
            :parent-content="agreementForm.content"></argeement-edit>
        </el-form-item>
        <el-form-item style="padding: 0; margin: 0;">
          <el-button
            @click="linkTo('/front/agreement/list')">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitArgeementForm('agreementForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import argeementEdit from "../../components/plugins/edit/argeementEdit";
export default {
  name: "argeementAdd",
  components: {
    argeementEdit,
  },
  data() {
    return {
      agreementForm: {
        content: `
                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    `
      },
      agreementFormRules: {},
      categorySelect: '',
      categorySelectVal: -1,
      categoryOptions: [
        {
          label: '车贷',
          value: 0,
        },
        {
          label: '导购',
          value: 1,
        },
        {
          label: '登录注册',
          value: 2,
        },
      ]
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    linkTo(url) {
      this.$router.push({ path: url });
    },
    show(data) {
      console.log(data);
    },
    showMsgFromEdit(data) {
      this.agreementForm.content = data;
    },
    categorySelectChange(val) {
      this.categorySelectVal = val;
    },
    addArgeement(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/front/agreement/add', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if (data.code) {
              this.$message({
                message: '新增协议成功',
                type: 'success'
              });
              this.linkTo('/front/agreement/list');
            } else {
              this.$alert('' + data.message, '错误提示', {
                confirmButtonText: '确定',
              });
            }
          }).catch(e => {
            this.$alert('' + e, '错误提示', {
              confirmButtonText: '确定',
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitArgeementForm(formName) {
      let reqParam = {
        title: this.agreementForm.title,
        agreementContent: this.agreementForm.content,
        agreementCategory: this.categorySelectVal,
      };
      this.addArgeement(formName, reqParam);
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.agreementForm = {
          content: `
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                        `
        };
        this.$refs[formName].resetFields();
        this.categorySelect = '';
        this.categorySelectVal = -1;
      })
    },
  },
  destroyed() {
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/front/agreementAdd.vue